import { render, staticRenderFns } from "./CoordinatorsModalSearchCoordinators.vue?vue&type=template&id=08e09c15&"
import script from "./CoordinatorsModalSearchCoordinators.vue?vue&type=script&lang=js&"
export * from "./CoordinatorsModalSearchCoordinators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports